const SETUP_STATUS_META = {
  STRONG_MATCH: { label: "⭐ STRONG SETUP MATCH", color: "#7c3aed" },
  MATCH: { label: "✓ SETUP MATCH", color: "#16a34a" },
  NEAR_MATCH: { label: "◐ NEAR MATCH", color: "#d97706" },
  NO_MATCH: { label: "— NO MATCH", color: "#64748b" },
  PREMIUM_PROTECTION: { label: "⚠ PREMIUM PROTECTION", color: "#dc2626" },
};

export const parseSetupList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  if (value == null || value === "") return [];
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value.replaceAll("'", '"'));
      if (Array.isArray(parsed)) return parsed.filter(Boolean).map(String);
    } catch (_) {
      return value.split(/[;,]/).map((item) => item.trim()).filter(Boolean);
    }
  }
  return [];
};

// This is the single presentation boundary for private setup fields.  Callers
// receive no setup object at all unless the authenticated app role is admin.
export const getPrivateTegSetup = (record, isAdmin) => {
  if (!isAdmin || !record) return null;
  const status = String(record.setup_match_status || "NO_MATCH").toUpperCase();
  const meta = SETUP_STATUS_META[status] || SETUP_STATUS_META.NO_MATCH;
  const score = Number(record.setup_match_score);
  return {
    status,
    label: meta.label,
    color: meta.color,
    score: Number.isFinite(score) ? score : null,
    direction: String(record.setup_match_direction || "NEUTRAL").toUpperCase(),
    matched: parseSetupList(record.setup_match_reasons),
    missing: parseSetupList(record.setup_match_missing),
    warnings: parseSetupList(record.setup_match_warnings),
  };
};

